import {
    keepPreviousData,
    useInfiniteQuery,
    useQueryClient
} from "@tanstack/react-query";
import CCService from "../services/httpServiceWithoutSuperAdmin";

const PAGE_SIZE = 16;

export const fetchCandidates = async ({
    pageParam = 1,
    job_id,
    tab,
}) => {
    const service = new CCService();
    try {
        const params = new URLSearchParams();
        params.set("page_size", PAGE_SIZE.toString());
        params.set("page_no", pageParam.toString());
        params.set("job_id", job_id.toString());

        const filter =
            tab === "saved" ? "bookmarked" : tab === "all" ? "all" : "applied";
        if (filter === "bookmarked") {
            params.set("is_bookmarked", "TRUE");
        } else if (filter === "applied") {
            params.set("is_applied", "TRUE");
        }

        if (tab === "all") {
            const response = await service.get(
                `/cee/recruiter/best-candidates?${params.toString()}`
            );

            const data = response?.data || [];

            return {
                data,
                total: data.length,
                hasMore: data.length === PAGE_SIZE,
            };
        } else {
            const response = await service.get(
                `/cee/recruiter/applied-candidates?${params.toString()}`
            );

            const data = response?.data || [];

            return {
                data,
                total: data.length,
                hasMore: data.length === PAGE_SIZE,
            };
        }
    } catch (error) {
        console.error("Error fetching candidates:", error);
        return {
            data: [],
            total: 0,
            hasMore: false,
        };
    }
};

const getCandidatesQueryKey = (job_id, tab) => [
    "candidates",
    job_id,
    tab,
];

export function useCandidates({ job_id, tab, enabled }) {
    return useInfiniteQuery({
        queryKey: getCandidatesQueryKey(job_id, tab),
        queryFn: ({ pageParam }) =>
            fetchCandidates({
                pageParam,
                job_id,
                tab,
            }),
        getNextPageParam: (lastPage, allPages) => {
            return lastPage.hasMore ? allPages.length + 1 : undefined;
        },
        initialPageParam: 1,
        staleTime: 30 * 60 * 1000,
        gcTime: 60 * 60 * 1000,
        refetchOnWindowFocus: false,
        placeholderData: keepPreviousData,
        enabled,
    });
}

export function usePrefetchCandidates() {
    const queryClient = useQueryClient();

    return (job_id, tab) => {
        queryClient.prefetchInfiniteQuery({
            queryKey: getCandidatesQueryKey(job_id, tab),
            queryFn: ({ pageParam }) =>
                fetchCandidates({
                    pageParam,
                    job_id,
                    tab,
                }),
            initialPageParam: 1,
            staleTime: 5 * 60 * 1000,
        });
    };
}
